/**
 * =============================================================================
 * geo-cart-delivery.js
 * =============================================================================
 * 
 * =============================================================================
 */

var GeoCartDelivery = {

  geodataJSON: undefined,
  isoCode: undefined,

  onReady: function(){
    document.addEventListener('geodata:loaded', this.handleGeodataLoaded.bind(this));
    document.addEventListener('minicart:rendered', this.updateBanner.bind(this));
    document.addEventListener('cart:changed', this.updateBanner.bind(this));
  },

  handleGeodataLoaded: function(event) {
    this.geodataJSON = event.detail.data;
    this.isoCode = this.geodataJSON.country.iso_code;
    this.updateBanner();
  },

  updateBanner: function() {
    if(!this.isoCode){
      return;
    }

    // Check we have any banners on the page
    var cartFreeDeliveryBanners = document.querySelectorAll(".cart-free-delivery-banner");
    if(cartFreeDeliveryBanners.length === 0){
      return;
    }

    var that = this;
    cartFreeDeliveryBanners.forEach(function(cartFreeDeliveryBanner) {
      // Check if we're in an excluded country. If so, show excluded message, return
      var excludedCountries = cartFreeDeliveryBanner.dataset.excludedCountries.split(",");
      if(excludedCountries.includes(that.isoCode)){
        var excludedCountryMessage = cartFreeDeliveryBanner.querySelector("[data-excluded-country]");
        excludedCountryMessage.classList.remove("d-none");
        //console.log("[G-C-D] Excluded country");
        return;
      }

      // Get the applicable banner element
      var applicableBanner = cartFreeDeliveryBanner.querySelector('[data-applicable-countries*="'+that.isoCode+'"]');
      if(applicableBanner == null) {
        applicableBanner = cartFreeDeliveryBanner.querySelector('[data-applicable-countries="rotw"]');
      }

      // Check if current spend matches required spend
      var spend = parseInt(cartFreeDeliveryBanner.dataset.spend);
      var spendFormatted = MP.Utilities.formatMoney(spend, theme.moneyFormat);
      var thresholdToMeet = parseInt(applicableBanner.dataset.threshold);
      var spendRequired = Math.abs(thresholdToMeet - spend);
      var spendRequiredFormatted = MP.Utilities.formatMoney(spendRequired, theme.moneyFormat);

      // console.log("[G-C-D] Formatted spend", spendFormatted);
      // console.log("[G-C-D] Applicable banner", applicableBanner);
      // console.log("[G-C-D] Threshold to meet", thresholdToMeet);

      // Update banner messages to replace placeholders - {{ country }}, {{ spend }}, {{ spend_remaining }}, {{ flag }}
      var allBanners = cartFreeDeliveryBanner.querySelectorAll('[data-applicable-countries]');
      allBanners.forEach(function(element){
        element.innerHTML = element.innerHTML
          .replace(new RegExp('{{ country }}', 'g'), that.isoCode)
          .replace(new RegExp('{{ spend }}', 'g'), spendFormatted)
          .replace(new RegExp('{{ spend_remaining }}', 'g'), spendRequiredFormatted)
          .replace(new RegExp('.00', 'g'), '')
          .replace(new RegExp('{{ flag }}', 'g'), "<img style='width:25px' alt='' src='https://flagcdn.com/w40/" + that.isoCode.toLowerCase() + ".jpg'/>");
      });

      // Hide irrelevant message
      if(spend < thresholdToMeet) {
        // console.log("[G-C-D] Not met threshold");
        applicableBanner.querySelector("[data-threshold-met]").classList.add("d-none");
      } else {
        // console.log("[G-C-D] Met threshold");
        applicableBanner.querySelector("[data-threshold-not-met]").classList.add("d-none");
      }

      // Unhide the overall banner
      applicableBanner.classList.remove("d-none");

    });
  }
};

export default GeoCartDelivery;